module.exports = __webpack_public_path__ + "static/media/login_logo.bbaa1597.svg";